import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);

  // PHP endpoint for newsletter
  const PHP_ENDPOINT = 'https://fusion-hub.us/sendmail.php';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMsg(null);
    setSubmitSuccess(null);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('newsletter', email);
      // If you want to support attachments in future, just add: formDataToSend.append('attachment', file)
      const res = await fetch(PHP_ENDPOINT, {
        method: 'POST',
        body: formDataToSend,
      });
      const result = await res.json();
      if (result.success) {
        setSubmitMsg('Thank you for subscribing!');
        setSubmitSuccess(true);
        setEmail('');
      } else {
        setSubmitMsg(result.message || 'Subscription failed.');
        setSubmitSuccess(false);
      }
    } catch (error) {
      setSubmitMsg(error.message || 'Subscription failed.');
      setSubmitSuccess(false);
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <>
      <div className="newsletter-area mg-top-110">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-10 text-center">
              <div className="section-title">
                <h2 className="title">
                  Get Our Latest <span>Newsletter</span>
                </h2>
                <p className='text-center'>Offer your business with the best assistance for growth.</p>
              </div>
              <div className="newsletter-subscribe">
                <form id="news-subscribe-form" className="subscribe-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your E-mail..."
                      name="mail"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button type="submit" className="btn-green subscribe-submit">
                      Submit
                    </button>
                  </div>
                </form>
                <div style={{ minHeight: 40, marginTop: 16 }}>
                  {submitting && (
                    <div className="form-loader" style={{textAlign:'center'}}>
                      <div className="spinner" style={{display:'inline-block',width:32,height:32,border:'4px solid #eee',borderTop:'4px solid #0d3a6b',borderRadius:'50%',animation:'spin 1s linear infinite'}}></div>
                      <style>{`@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
                      <div style={{marginTop:8,color:'#888'}}>Submitting...</div>
                    </div>
                  )}
                  {submitMsg && (
                    <div style={{
                      textAlign: 'center',
                      color: submitSuccess ? '#219150' : '#d32f2f',
                      background: submitSuccess ? '#eafaf1' : '#fdeaea',
                      border: submitSuccess ? '1px solid #b6e5c7' : '1px solid #f3bcbc',
                      borderRadius: 6,
                      padding: '10px 0',
                      fontWeight: 500,
                      marginTop: submitting ? 12 : 0
                    }}>
                      {submitMsg}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
